module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('div', {
    staticClass: "issues-navbar-filters",
    attrs: {
      "slot": "navbarFilters"
    },
    slot: "navbarFilters"
  }, [_c('div', {
    ref: "filterSA",
    staticClass: "ui multiple dropdown issues-navbar-dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "filter"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "users icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text issues-navbar-dd-summary"
  }, [_vm._v("S.Accounts: All")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Seller Accounts")]), _vm._v(" "), _c('div', {
    staticClass: "scrolling menu"
  }, _vm._l(((_vm.sellerAccountsList || [])), function(sa) {
    return _c('div', {
      key: sa.sellerId,
      staticClass: "item",
      attrs: {
        "data-value": sa.sellerId
      }
    }, [_c('i', {
      class: (sa.region === 'NA' ? 'olive' : 'teal') + ' circle compact icon'
    }), _vm._v(_vm._s(sa.accountNickName) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    ref: "filterC",
    staticClass: "ui multiple dropdown issues-navbar-dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "filter"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "globe icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text issues-navbar-dd-summary"
  }, [_vm._v("Marketplaces: All")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Marketplaces")]), _vm._v(" "), _c('div', {
    staticClass: "scrolling menu"
  }, _vm._l((_vm.filterCountriesForDropdown), function(c) {
    return _c('div', {
      key: c,
      class: c === 's' ? 'divider' : 'item',
      attrs: {
        "data-value": c
      }
    }, [(c !== 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag'
    }) : _vm._e(), _vm._v(_vm._s(c !== 's' ? c : '') + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    ref: "filterDate",
    staticClass: "ui dropdown issues-navbar-dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "daterange"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Date Range: " + _vm._s(_vm.dateRangeLabel))]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "today"
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "7d"
    }
  }, [_vm._v("Last 7 Days")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "30d"
    }
  }, [_vm._v("Last 30 Days")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "90d"
    }
  }, [_vm._v("Last 90 Days")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "all"
    }
  }, [_vm._v("All Time")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "custom"
    }
  }, [_vm._v("Custom range…")])])]), _vm._v(" "), (_vm.showCustomDatePicker) ? _c('form', {
    staticClass: "issues-custom-date-range",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.applyCustomDateRange.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customDraftStart),
      expression: "customDraftStart"
    }],
    attrs: {
      "type": "date",
      "min": _vm.customDateMin,
      "max": _vm.customDraftEnd || _vm.customDateMax,
      "aria-label": "Start date",
      "required": ""
    },
    domProps: {
      "value": (_vm.customDraftStart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customDraftStart = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "issues-custom-date-sep"
  }, [_vm._v("–")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customDraftEnd),
      expression: "customDraftEnd"
    }],
    attrs: {
      "type": "date",
      "min": _vm.customDraftStart || _vm.customDateMin,
      "max": _vm.customDateMax,
      "aria-label": "End date",
      "required": ""
    },
    domProps: {
      "value": (_vm.customDraftEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customDraftEnd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "issues-custom-date-btn primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.customDraftValid
    }
  }, [_vm._v("Apply")]), _vm._v(" "), _c('button', {
    staticClass: "issues-custom-date-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelCustomDateRange
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('span', {
    staticClass: "issues-custom-date-hint"
  }, [_vm._v("Last 90 days only")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "issues-dashboard"
  }, [_c('div', {
    staticClass: "issues-main-layout"
  }, [_c('AlertCategoriesSidebar', {
    attrs: {
      "alertCounts": _vm.wdAlertCounts,
      "activeCategory": _vm.activeCategory
    },
    on: {
      "select": _vm.scrollToWatchdog
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "issues-main-content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "issues-loading-state"
  }, [_c('i', {
    staticClass: "spinner loading icon"
  }), _vm._v(" "), _c('p', [_vm._v("Loading alerts…")])]) : (_vm.error) ? _c('div', {
    staticClass: "issues-error-state"
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v(" "), _c('h3', [_vm._v("Failed to load alerts")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "issues-retry-btn",
    on: {
      "click": _vm.fetchWatchdogsData
    }
  }, [_vm._v("Retry")])]) : _c('div', {
    key: "1",
    staticClass: "wide",
    attrs: {
      "id": "wdCont"
    }
  }, [_c('div', {
    staticClass: "issues-category-list-wrapper",
    attrs: {
      "id": "context"
    }
  }, _vm._l((_vm.displayedWatchdogs), function(i) {
    return (_vm.issuesWorldStore && _vm.issuesWorldStore.watchDogs[i]) ? _c('IssuesCategoryDetail', {
      key: i,
      attrs: {
        "wdtype": i,
        "wd": _vm.issuesWorldStore.watchDogs[i],
        "filterByMarket": _vm.filterByMarket,
        "filterBySellAcc": _vm.filterBySellAcc,
        "dateRange": 'all',
        "issues-list-tab": _vm.issuesListTab,
        "resolved-hidden": _vm.issuesResolvedHidden,
        "marketplace-filter-options": _vm.marketplaceColumnOptions,
        "highlighted-alert-id": _vm.highlightedAlertId,
        "items-meta": _vm.issuesItemsMeta,
        "fee-direction": _vm.issuesFeeDirection,
        "items-loading": _vm.issuesItemsLoading,
        "alert-thresholds-api-base-url": _vm.alertThresholdsApiBaseUrl,
        "stock-alert-thresholds-api-base-url": _vm.stockAlertThresholdsApiBaseUrl,
        "sales-volume-thresholds-api-base-url": _vm.salesVolumeThresholdsApiBaseUrl,
        "issue-products": _vm.issueProductsMap
      },
      on: {
        "issues-tab-change": _vm.onIssuesTabChange,
        "alert-counts-delta": _vm.onAlertCountsDelta,
        "issues-page-change": _vm.onIssuesPageChange,
        "issues-search-change": _vm.onIssuesSearchChange,
        "issues-fee-direction-change": _vm.onIssuesFeeDirectionChange,
        "issues-summary-refresh-request": _vm.onIssuesSummaryRefreshRequest,
        "filter-market": _vm.onMarketplaceColumnFilter
      }
    }) : _vm._e()
  }), 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "height": "100vh",
      "width": "100vw",
      "background-color": "rgba(0,0,0,.6)",
      "pointer-events": "none",
      "z-index": "11",
      "display": "none"
    },
    attrs: {
      "id": "darkbackgr"
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b0b5163!./~/vue-loader/lib/selector.js?type=template&index=0!./src/IssuesPage.vue
// module id = 754
// module chunks = 2